import {
  WSSelect,
  WSSelectOption,
  WSSelectProps
} from "@wingspanhq/fe-component-library";
import { Nullable } from "primereact/ts-helpers";
import { useMemo } from "react";
import { MethodsData, MethodValue } from "./ManageMethods/types";
import { getMethods } from "./ManageMethods/utils";

export type SelectMethodProps = {
  data: MethodsData;
  value: Nullable<MethodValue>;
  onChange: (value: Nullable<MethodValue>) => void;
} & Omit<WSSelectProps, "options" | "value" | "onChange">;

export const SelectMethod: React.FC<SelectMethodProps> = ({
  value,
  onChange,
  ...props
}) => {
  const methodsByCountry = useMemo(() => {
    return getMethods(props.data);
  }, [props.data]);

  const options = useMemo(() => {
    const options: WSSelectOption[] = [];
    methodsByCountry.forEach(({ methods }) => {
      methods.forEach(method => {
        options.push({
          value: method.id,
          label: [
            method.label.text,
            method.label.link?.label,
            method.label.secondaryText
          ]
            .filter(Boolean)
            .join(" "),
          avatar: method.label.avatar,
          labels: method.label.helperText
            ? [method.label.helperText]
            : undefined
        });
      });
    });

    return options;
  }, [methodsByCountry]);

  return (
    <WSSelect
      value={value ? value.id : null}
      onChange={value => {
        if (!value) {
          onChange(null);
          return;
        }

        for (const country of methodsByCountry) {
          for (const method of country.methods) {
            if (method.id === value) {
              onChange({
                id: value,
                type: method.type
              });
              return;
            }
          }
        }

        console.assert(
          false,
          "Method not found during onChange in SelectMethod"
        );
      }}
      options={options}
      {...props}
    />
  );
};
